<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title"> Course Test </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark color="white">fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-stepper v-model="e1" :steps="questions" ref="myStepper">
      <v-stepper-header>
        <template v-for="(n, index) in questions">
          <v-stepper-step
            v-if="questions.length > 1"
            :key="`${n.id}-step`"
            :complete="e1 > index"
            :step="index + 1"
            color="primary"
          ></v-stepper-step>

          <v-divider v-if="n !== questions" :key="n.id"></v-divider>
        </template>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content
          v-for="(question, index) in questions"
          :key="`${question.id}-content`"
          :step="index + 1"
        >
          <h4>{{ question.question }}</h4>
          <v-container
            v-if="question.question_type == 1"
            style="padding-left: 0 !important; padding-right: 0 !important"
          >
            <v-radio-group
              v-model="answers[question.id]"
              :mandatory="false"
              :key="index"
            >
              <v-radio
                v-if="question.a !== null && question.a !== ''"
                :label="question.a"
                value="a"
                @change="enableNext"
              ></v-radio>
              <v-radio
                v-if="question.b !== null && question.b !== ''"
                :label="question.b"
                value="b"
                @change="enableNext"
              ></v-radio>
              <v-radio
                v-if="question.c !== null && question.c !== ''"
                :label="question.c"
                value="c"
                @change="enableNext"
              ></v-radio>
              <v-radio
                v-if="question.d !== null && question.d !== ''"
                :label="question.d"
                value="d"
                @change="enableNext"
              ></v-radio>
              <v-radio
                v-if="question.e !== null && question.e !== ''"
                :label="question.e"
                value="e"
                @change="enableNext"
              ></v-radio>
              <v-radio
                v-if="question.f !== null && question.f !== ''"
                :label="question.f"
                value="f"
                @change="enableNext"
              ></v-radio>
              <v-radio
                v-if="question.g !== null && question.g !== ''"
                :label="question.g"
                value="g"
                @change="enableNext"
              ></v-radio>
              <v-radio
                v-if="question.h !== null && question.h !== ''"
                :label="question.h"
                value="h"
                @change="enableNext"
              ></v-radio>
              <v-radio
                v-if="question.i !== null && question.i !== ''"
                :label="question.i"
                value="i"
                @change="enableNext"
              ></v-radio>
              <v-radio
                v-if="question.j !== null && question.j !== ''"
                :label="question.j"
                value="j"
                @change="enableNext"
              ></v-radio>
            </v-radio-group>
          </v-container>
          <v-container v-if="question.question_type == 2">
            <v-text-field
              v-if="question.a !== null && question.a !== ''"
              v-model="answers[question.id]"
              label="Answer"
              type="text"
              filled
              @change="enableNext(question.question_type)"
              @keypress="enableNext(question.question_type)"
            >
            </v-text-field>
          </v-container>
          <v-container fluid v-if="question.question_type == 3">
            <v-checkbox
              v-if="question.a !== null && question.a !== ''"
              :label="question.a"
              value="a"
              @change="enableNext(question.question_type, question.id)"
              v-model="multi_answers"
            ></v-checkbox>
            <v-checkbox
              v-if="question.b !== null && question.b !== ''"
              :label="question.b"
              value="b"
              @change="enableNext(question.question_type, question.id)"
              v-model="multi_answers"
            ></v-checkbox>
            <v-checkbox
              v-if="question.c !== null && question.c !== ''"
              :label="question.c"
              value="c"
              @change="enableNext(question.question_type, question.id)"
              v-model="multi_answers"
            ></v-checkbox>
            <v-checkbox
              v-if="question.d !== null && question.d !== ''"
              :label="question.d"
              value="d"
              @change="enableNext(question.question_type, question.id)"
              v-model="multi_answers"
            ></v-checkbox>
            <v-checkbox
              v-if="question.e !== null && question.e !== ''"
              :label="question.e"
              value="e"
              @change="enableNext(question.question_type, question.id)"
              v-model="multi_answers"
            ></v-checkbox>
            <v-checkbox
              v-if="question.f !== null && question.f !== ''"
              :label="question.f"
              value="f"
              @change="enableNext(question.question_type, question.id)"
              v-model="multi_answers"
            ></v-checkbox>
            <v-checkbox
              v-if="question.g !== null && question.g !== ''"
              :label="question.g"
              value="g"
              @change="enableNext(question.question_type, question.id)"
              v-model="multi_answers"
            ></v-checkbox>
            <v-checkbox
              v-if="question.h !== null && question.h !== ''"
              :label="question.h"
              value="h"
              @change="enableNext(question.question_type, question.id)"
              v-model="multi_answers"
            ></v-checkbox>
            <v-checkbox
              v-if="question.i !== null && question.i !== ''"
              :label="question.i"
              value="i"
              @change="enableNext(question.question_type, question.id)"
              v-model="multi_answers"
            ></v-checkbox>
            <v-checkbox
              v-if="question.j !== null && question.j !== ''"
              :label="question.j"
              value="j"
              @change="enableNext(question.question_type, question.id)"
              v-model="multi_answers"
            ></v-checkbox>
          </v-container>
          <v-container v-if="question.question_type == 4">
            <div v-if="question.a !== ''">
              {{ question.a }}
              <v-select
                :items="
                  multipleChoiceOptions.filter((e) => {
                    return e.qid == question.id;
                  })
                "
                v-model="associate_answer1[question.id]"
                item-value="id"
                item-text="name"
                label="Associate Option"
                filled
                @change="enableNext(question.question_type, question.id)"
              >
              </v-select>
            </div>
            <div v-if="question.b !== ''">
              {{ question.b }}
              <v-select
                :items="
                  multipleChoiceOptions.filter((e) => {
                    return e.qid == question.id;
                  })
                "
                v-model="associate_answer2[question.id]"
                item-value="id"
                item-text="name"
                label="Associate Option"
                filled
                @change="enableNext(question.question_type, question.id)"
              >
              </v-select>
            </div>
            <div v-if="question.c">
              {{ question.c }}
              <v-select
                :items="
                  multipleChoiceOptions.filter((e) => {
                    return e.qid == question.id;
                  })
                "
                v-model="associate_answer3[question.id]"
                item-value="id"
                item-text="name"
                label="Associate Option"
                filled
                @change="enableNext(question.question_type, question.id)"
              >
              </v-select>
            </div>
            <div v-if="question.d">
              {{ question.d }}
              <v-select
                :items="
                  multipleChoiceOptions.filter((e) => {
                    return e.qid == question.id;
                  })
                "
                v-model="associate_answer4[question.id]"
                item-value="id"
                item-text="name"
                label="Associate Option"
                filled
                @change="enableNext(question.question_type, question.id)"
              >
              </v-select>
            </div>
            <div v-if="question.e">
              {{ question.e }}
              <v-select
                :items="
                  multipleChoiceOptions.filter((e) => {
                    return e.qid == question.id;
                  })
                "
                v-model="associate_answer5[question.id]"
                item-value="id"
                item-text="name"
                label="Associate Option"
                filled
                @change="enableNext(question.question_type, question.id)"
              >
              </v-select>
            </div>
          </v-container>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-footer height="68">
      <v-flex px-4 py-4 text-right action-button-div>
        <div>
          <v-btn
            v-if="e1 > 1"
            color="dark-blue"
            class="ml-2 add-course-button"
            @click="back"
            >Back</v-btn
          >
          <v-btn
            v-else
            disabled
            color="dark-blue"
            class="ml-2 add-course-button"
            @click="back"
            >Back</v-btn
          >
        </div>
        <div v-if="finished">
          <span v-if="enableButton">
            <v-btn
              v-if="submitted"
              color="primary"
              class="ml-2"
              loading
            ></v-btn>
            <v-btn
              v-else
              color="primary"
              class="ml-2 add-course-button"
              @click="submitAnswers"
              >Finish</v-btn
            >
          </span>
          <span v-else>
            <v-btn
              color="primary"
              disabled
              class="ml-2 add-course-button"
              @click="submitAnswers"
              >Finish</v-btn
            >
          </span>
        </div>
        <div v-else>
          <v-btn
            v-if="enableButton"
            color="dark-blue"
            class="ml-2 add-course-button"
            @click="next"
            >Next</v-btn
          >
          <v-btn
            v-else
            disabled
            color="dark-blue"
            class="ml-2 add-course-button"
            @click="next"
            >Next</v-btn
          >
        </div>
      </v-flex>
    </v-footer>
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="415">
          <template v-slot:activator="{ on, attrs }">
            <!--<v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn>-->
          </template>
          <v-card>
            <v-card-title class="text-h5" color="primary">
              User Agree Statement
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>{{ this.agreeStatement }}</v-card-text>
            <v-text-field
              v-model="signed_name"
              label="Name"
              type="text"
              filled
              style="padding: 16px 24px 10px"
              @keypress="enableAcceptBtn()"
            >
            </v-text-field>
            <v-card-actions v-if="enableAccept" class="pa-2">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="ml-2 add-course-button"
                @click="processSubmitAnswers(0)"
              >
                Disagree
              </v-btn>
              <v-btn
                color="primary"
                class="ml-2 add-course-button"
                @click="processSubmitAnswers(1)"
              >
                Agree
              </v-btn>
            </v-card-actions>
            <v-card-actions v-if="!enableAccept" class="pa-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" class="ml-2 add-course-button" disabled>
                Disagree
              </v-btn>
              <v-btn color="primary" class="ml-2 add-course-button" disabled>
                Agree
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import testAPI from '@/api/test.js';
export default {
  name: 'CourseTest',
  components: {},
  data() {
    return {
      loading: false,
      e1: 1,
      answers: {},
      finished: false,
      enableButton: false,
      submitted: false,
      multi_answers: [],
      fill_answer: null,
      multipleChoiceAnswer: {},
      list: ['f', 'g', 'h', 'i', 'j'],
      multipleChoiceOptions: [],
      associate_answer1: {},
      associate_answer2: {},
      associate_answer3: {},
      associate_answer4: {},
      associate_answer5: {},
      agreeStatement: '',
      dialog: false,
      enableAccept: false,
      signed_name: '',
      associationQueArr: {},
      multipleChoiceAnswer1: [],
      associateAnswerCount: 0,
      reviewSubmittedAnswer:
        'we are just checking your answers. We will have your results shortly.',
      backdrop: 0.3,
    };
  },
  props: {
    course: {
      type: Object,
      default: null,
    },
  },
  computed: {
    quiz: function () {
      return this.$store.getters.test;
    },
    questions: function () {
      //return this.course.test ? this.course.test.data.questions : [];
      this.agreeStatement = this.$store.getters.test.agree_statement;
      let coreQuestion = this.$store.getters.test.core_questions;
      let regularQuestion = this.$store.getters.test.questions;
      let allQuestion = coreQuestion.concat(regularQuestion);
      return allQuestion;
    },
    mappedAnswers: function () {
      return this.questions.map((x, i) => {
        if (x.question_type == 3)
          return {
            id: x.id,
            question_type: x.question_type,
            value: this.multipleChoiceAnswer,
          };
        else if (x.question_type == 4)
          return {
            id: x.id,
            question_type: x.question_type,
            value: {
              1: this.associate_answer1[x.id],
              2: this.associate_answer2[x.id],
              3: this.associate_answer3[x.id],
              4: this.associate_answer4[x.id],
              5: this.associate_answer5[x.id],
            },
          };
        else
          return {
            id: x.id,
            question_type: x.question_type,
            value: this.answers[x.id],
          };
      });
    },
  },
  mounted() {
    this.pickRandomOptions();
  },
  watch: {
    e1: {
      handler() {
        if (this.e1 == this.questions.length) {
          this.finished = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    closePanel() {
      this.$emit('closePanel');
    },
    next() {
      var check;
      this.e1++;
      this.multi_answers =
        !this.finished &&
        this.multipleChoiceAnswer1.hasOwnProperty(this.e1) &&
        this.multipleChoiceAnswer1[this.e1].length > 0
          ? this.multipleChoiceAnswer1[this.e1]
          : [];

      this.multipleChoiceAnswer1.forEach(function (x) {
        check = x.length > 1;
      });

      if (check === undefined) {
        this.enableButton =
          Object.keys(this.answers).length +
            Object.keys(this.multipleChoiceAnswer).length +
            this.associateAnswerCount >=
          this.e1
            ? true
            : false;
      } else {
        this.enableButton =
          Object.keys(this.answers).length +
            Object.keys(this.multipleChoiceAnswer).length +
            this.associateAnswerCount >=
            this.e1 && check
            ? true
            : false;
      }
    },
    back() {
      this.e1--;
      this.multi_answers = this.multipleChoiceAnswer1[this.e1];
      this.enableButton = true;
      this.finished = false;
    },
    enableNext(type, id) {
      if (this.questions.length == 1) {
        this.finished = true;
      }

      if (type == 4) {
        this.enableButton = true;
        var foundQuestion = this.questions.filter((key) => {
          return id == key.id;
        });

        // Check if question is exist and option selected
        if (
          foundQuestion[0].a != null &&
          Object.keys(this.associate_answer1).length == 0
        ) {
          this.enableButton = false;
        } else if (
          foundQuestion[0].b != null &&
          Object.keys(this.associate_answer2).length == 0
        ) {
          this.enableButton = false;
        } else if (
          foundQuestion[0].c != null &&
          Object.keys(this.associate_answer3).length == 0
        ) {
          this.enableButton = false;
        } else if (
          foundQuestion[0].d != null &&
          Object.keys(this.associate_answer4).length == 0
        ) {
          this.enableButton = false;
        } else if (
          foundQuestion[0].e != null &&
          Object.keys(this.associate_answer5).length == 0
        ) {
          this.enableButton = false;
        }

        if (this.enableButton) {
          this.associateAnswerCount += 1;
        }
      }

      if (this.multi_answers.length >= 2 && type == 3) {
        this.multipleChoiceAnswer[id] = this.multi_answers;
        this.multipleChoiceAnswer1[this.e1] = this.multi_answers;
        this.enableButton = true;
      } else if (this.multi_answers.length < 2 && type == 3) {
        this.multipleChoiceAnswer[id] = this.multi_answers;
        this.multipleChoiceAnswer1[this.e1] = this.multi_answers;
        this.enableButton = false;
      } else if (type != 3 && type != 4) {
        this.enableButton = true;
      }
    },
    enableAcceptBtn() {
      if (this.signed_name != '') {
        this.enableAccept = true;
      }
    },
    submitAnswers() {
      this.submitted = true;
      this.$snotify.info(this.reviewSubmittedAnswer, {
        backdrop: 0.3,
      });
      testAPI
        .getScore(
          this.quiz.id,
          this.mappedAnswers,
          this.$store.getters.userStats.id
        )
        .then((response) => {
          if (
            response.data.passed &&
            this.agreeStatement != '' &&
            this.agreeStatement != null
          )
            this.dialog = true;
          else this.processSubmitAnswers();
        });
    },
    processSubmitAnswers(agree = '') {
      this.dialog = false;
      this.submitted = true;
      testAPI
        .submitResults(
          this.quiz.id,
          this.mappedAnswers,
          this.$store.getters.userStats.id,
          agree,
          this.signed_name
        )
        .then((response) => {
          EventBus.$emit('ANSWERS_SUBMITTED', response);
          this.$emit('closePanel');
        });
    },
    pickRandomOptions() {
      this.list.sort(() => Math.random() - 0.5);
      this.questions.forEach((value, index) => {
        if (value.question_type == 4) {
          this.list.forEach((option, key) => {
            if (option == 'f' && value.f !== null && value.f !== '') {
              this.multipleChoiceOptions.push({
                qid: value.id,
                id: value.f,
                name: value.f,
              });
            }
            if (option == 'g' && value.g !== null && value.g !== '') {
              this.multipleChoiceOptions.push({
                qid: value.id,
                id: value.g,
                name: value.g,
              });
            }
            if (option == 'h' && value.h != null && value.h !== '') {
              this.multipleChoiceOptions.push({
                qid: value.id,
                id: value.h,
                name: value.h,
              });
            }
            if (option == 'i' && value.i != null && value.i !== '') {
              this.multipleChoiceOptions.push({
                qid: value.id,
                id: value.i,
                name: value.i,
              });
            }
            if (option == 'j' && value.j != null && value.j !== '') {
              this.multipleChoiceOptions.push({
                qid: value.id,
                id: value.j,
                name: value.j,
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
#popup-container .v-input__slot {
  border-bottom: 0px solid rgba(0, 0, 0, 0.6) !important;
}
.v-stepper__header {
  overflow-x: auto !important;
  flex-wrap: nowrap !important;
  gap: 1em !important;
}

/* .v-stepper__step {
  padding: 24px 5px !important;
} */
</style>
